import React, {useEffect, useState} from 'react';
import style from "./productsPage.module.scss";
import {useProducts} from "../../hooks/products.hook";
import Nav from "../../components/ui/nav/nav";
import {useCatalogs} from "../../hooks/catalogs.hook";
import {closestCenter, DndContext} from "@dnd-kit/core";
import {restrictToParentElement, restrictToVerticalAxis} from "@dnd-kit/modifiers";
import {SortableContext, verticalListSortingStrategy} from "@dnd-kit/sortable";
import {useSortableList} from "../catalogs/hoock/useSortableList";
import ProductItem from "./components/productItem/productItem";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import "./custom-scrollbar.scss"
import {ProductPopup} from "./popups/productPopup";
import ConfirmDeletePopup from "../../components/popups/confirmDeletePopup";

const ProductsPage = () => {

    const [catalogId, setCatalogId] = useState(-1);

    const {products, deleteProduct, updateOrder, update, create} = useProducts(catalogId)
    const {catalogsSubData} = useCatalogs(-1)
    const [popupData, setPopupData] = React.useState({visible: false, categoryId: -1, data: {}})
    const [productToDelete, setProductToDelete] = useState(null)

    useEffect(() => {
        if (catalogId === -1 && catalogsSubData?.length > 0) {
            setCatalogId(catalogsSubData[0].id)
        }
    }, [catalogId, catalogsSubData])

    const handleChangeCatalog = (e) => {
        setCatalogId(e.currentTarget.value)
    }

    const {items, handleDragEnd} = useSortableList(products);

    const dragEnd = (e) => {
        const newItems = handleDragEnd(e)
        const newIds = newItems.map(item => item.id);
        console.log(newIds)
        updateOrder(newIds)
    }

    return (
        <div className="page">
            <div className="page_container">
                <div className={style.block}>
                    <ProductPopup active={popupData} setActive={setPopupData} create={create} update={update}/>
                    <ConfirmDeletePopup
                        active={productToDelete && {
                            title: "Удалить товар?",
                            message: `Товар «${productToDelete.title}» будет удален без возможности восстановления.`
                        }}
                        onCancel={() => setProductToDelete(null)}
                        onConfirm={() => {
                            deleteProduct(productToDelete.id);
                            setProductToDelete(null);
                        }}
                    />
                    <Nav title="Товары">
                        <div className={style.body}>
                            <div className={style.row}>
                                <div className={style.selectCatalog}>
                                    <div className={style.selectCatalog__title}>Каталог</div>
                                    <div className={style.selectCatalog__select}>
                                        <select value={catalogId} onChange={handleChangeCatalog}>
                                            {
                                                catalogsSubData?.length > 0 && catalogsSubData?.map(item =>
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                )
                                            }
                                        </select>
                                        <div className={style.selectCatalog__arrow}>
                                            <svg width="16" height="6" viewBox="0 0 16 6" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 0.75L8 5.25L15 0.75" stroke="#D2D2D2" strokeLinecap="round"
                                                      strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <button
                                    className={style.btnCreate}
                                    onClick={() => setPopupData({visible: true, categoryId: catalogId, data: {}})}
                                >
                                    Добавить
                                </button>
                            </div>
                            <div className={style.table}>
                                <div className={style.tableHeader}>
                                    <div>Название</div>
                                    <div>Публикация</div>
                                    <div>Цена</div>
                                </div>
                                <SimpleBar className={style.tableBody} style={{overflowX: "hidden"}}>
                                    <div>
                                        <DndContext
                                            collisionDetection={closestCenter}
                                            onDragEnd={dragEnd}
                                            modifiers={[restrictToVerticalAxis,
                                                restrictToParentElement,]}
                                        >
                                            {items?.length > 0 ?
                                                <SortableContext
                                                    items={items}
                                                    strategy={verticalListSortingStrategy}
                                                    style={{overflowX: "hidden"}}
                                                >
                                                    {items.map(product =>
                                                        <ProductItem
                                                            key={product.id}
                                                            product={product}
                                                            update={update}
                                                            requestDelete={(product) => setProductToDelete(product)}
                                                            openProductPopup={(data) => setPopupData(data)}
                                                            categoryId={catalogId}
                                                        />
                                                    )}
                                                </SortableContext>
                                            : <div></div>}
                                        </DndContext>
                                    </div>

                                </SimpleBar>
                                <div className={style.tableFooter}>
                                    <div>Всего: {products?.length || 0}</div>
                                </div>
                            </div>
                        </div>
                    </Nav>
                </div>
            </div>
        </div>
    );
};

export default ProductsPage;